var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"px-4 text-center text-capitalize table-btn px-4 py-1 unclickable-status",class:{
    'bg-red-danger': _vm.status == 'unpaid',
    'bg-green-success': _vm.status == 'paid',
    'green-btn': _vm.status == 'settled',
    'bg-secondary': _vm.status == 'requested'
  },attrs:{"pill":"","variant":"success","size":_vm.size}},[_vm._v(_vm._s(_vm.status))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }